import React from 'react'
import Row from '../components/Shared/Row'
import Column from '../components/Shared/Column'
import Helmet from 'react-helmet'

import Hero from '../components/ProgramOverview/Hero'


export default class AdvisoryCouncil extends React.Component {

    sort() {
        return this.props.data.allContentfulAdvisoryCouncil.edges.sort(function compare(a, b) {
            var dateA = new Date(a.node.updatedAt);
            var dateB = new Date(b.node.updatedAt);
            return dateA - dateB;
        })
    }

    render() {
        // console.log('this.props ======> ',this.props)
        const sortedArray = this.sort()
        // console.log('THE SORTED ARRAY === ', sortedArray)
        return (
            <div>
                <Helmet title="Advisory Council | Global Citizen Year" />
                <div>
                    <Hero title="Advisory Council" />
                </div>
                <Row className="capper">
                    { sortedArray.map( (member, index) => {
                        if( member.node.emeritusBoard !== true ) {
                            return (
                                <Column key={ index } width="4" tablet="6" mobile="12">
                                    <div style={{ padding:'20px' }}>
                                        <h2 style={{ marginBottom:'10px' }}>{ member.node.name }</h2>
                                        <p>{ member.node.additionalDetails.additionalDetails }</p>
                                    </div>
                                </Column>
                            )
                        }
                    })}
                </Row>
                <Row className="no-top-padding capper">
                    <Column width="12">
                        <h2 className="h2" style={{ textAlign: 'center' }}>Emeritus Board</h2>
                        <hr style={{ margin:'20px auto', height:'1px', background:'#ededed' }}/>
                    </Column>
                    { this.props.data.allContentfulAdvisoryCouncil.edges.map( ( member, index) => (
                        member.node.emeritusBoard &&
                            <Column key={ index } width="4" tablet="6" mobile="12">
                                <div style={{ padding:'20px' }}>
                                    <h2 style={{ marginBottom:'10px' }}>{ member.node.name }</h2>
                                    <p>{ member.node.additionalDetails.additionalDetails }</p>
                                </div>
                            </Column>
                    ))}
                </Row>
            </div>
        )
    }
}



export const query = graphql`
query AdvisoryCouncileQuery {
   	allContentfulAdvisoryCouncil {
      edges {
		node {
          createdAt
          updatedAt
		  name
          emeritusBoard
          additionalDetails {
            additionalDetails
          }
        }
      }
    }
}`



// WEBPACK FOOTER //
// ./src/pages/advisory-council.js